// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminAuditPage_wrapper__3qVuY","table_container":"AdminAuditPage_table_container__1aY7k","user_table":"AdminAuditPage_user_table__16CX0"};